import React from "react";
import { Button, Icon, Toast } from "antd-mobile";
import { post } from "../../utils/request";
import { href, decode } from "../../utils/util";
import api from "./api";
import { loadingToast } from "../modules/loading";
import Cookies from "js-cookie";

import "./index.less";
var timer;
class ACFaceCa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            url: "",
            status: "loading",
            urlOps: {},
            backUrl: "",
            second: 5,
            secondType: false,
        };
    }
    componentDidMount() {
        if (window.location.href.indexOf("?url") > -1) {
            this.timeFN();
        } else {
            this.setState(
                {
                    status: "success",
                },
                () => {
                    //   this.generateSignUrl();
                    this.selectSignPlatForm();
                    window.history.go(-window.history.length);
                }
            );
        }
    }

    selectSignPlatForm = () => {
        let _this = this;
        let url = "";
        if (localStorage.getItem("app_stoken")) {
            url =
                api.h5.selectSignPlatForm +
                "?app_stoken=" +
                localStorage.getItem("app_stoken");
        } else if (localStorage.getItem("sessionKey")) {
            url =
                api.wechat.selectSignPlatForm +
                "?sessionKey=" +
                localStorage.getItem("sessionKey");
        } else {
            url =
                api.h5.selectSignPlatForm +
                "?session_key=" +
                Cookies.get("session_key");
        }
        post({
            url: url,
            data: {
                thirdContractId: localStorage.getItem("thirdContractId"),
            },
        }).then(
            (res) => {
                console.log("获取实名信息", res);
                if (res.result === "success") {
                    if (res.data.certificate == 1) {
                        this.generateSignUrl();
                    } else {
                        href(
                            `/ACGuide?mobileNumber=${this.state.urlOps.mobileNumber}&plateformType=${res.data.plateformType}`
                        );
                    }
                } else {
                    if (res.code == "-1") {
                        href("/ACLogin");
                        Toast.info("登录失效", 1);
                    } else {
                        Toast.info("获取实名信息失败", 1);
                    }
                }
            },
            (res) => {
                console.log("获取实名信息失败", res);
                if (res.code == "-1") {
                    href("/ACLogin");
                    Toast.info("登录失效", 1);
                } else {
                    Toast.info("获取实名信息失败", 1);
                }
            }
        );
    };

    timeFN = () => {
        let _this = this;
        clearInterval(timer);
        this.setState(
            {
                second: 5,
            },
            () => {
                let { second } = this.state;
                timer = setInterval(() => {
                    if (second < 0) {
                        clearInterval(timer);
                        if (window.location.href.indexOf("?url") > -1) {
                            var url1 = this.urlSplit(window.location.href);
                            const url = decode(url1.url);
                            var ops = this.urlSplit(url);
                            this.setState(
                                {
                                    urlOps: ops,
                                    backUrl:
                                        url.split("?")[0] +
                                        "?mobileNumber=" +
                                        ops.mobileNumber,
                                },
                                () => {
                                    if (ops.app_stoken) {
                                        localStorage.setItem(
                                            "app_stoken",
                                            ops.app_stoken
                                        );
                                        Cookies.remove("session_key");
                                        localStorage.removeItem("sessionKey");
                                        // this.checkCertification();
                                        this.selectSignPlatForm();
                                    } else if (ops.sessionKey) {
                                        // localStorage.setItem('thirdContractId',ops.thirdContractId);
                                        localStorage.setItem(
                                            "sessionKey",
                                            ops.sessionKey
                                        );
                                        Cookies.remove("session_key");
                                        localStorage.removeItem("app_stoken");
                                        // this.checkCertification();
                                        this.selectSignPlatForm();
                                    } else {
                                        localStorage.removeItem("app_stoken");
                                        localStorage.removeItem("sessionKey");
                                        if (Cookies.get("session_key")) {
                                            //   this.checkCertification();
                                            this.selectSignPlatForm();
                                        } else {
                                            href("/ACLogin");
                                        }
                                    }
                                }
                            );
                        } else {
                            //   this.generateSignUrl();
                            this.selectSignPlatForm();
                            window.history.go(-window.history.length);
                        }
                    } else {
                        _this.setState({
                            second: second--,
                        });
                    }
                }, 1000);
            }
        );
    };

    urlSplit = (url) => {
        var obj = "",
            obj1 = "",
            ops = {};
        if (url.indexOf("?") > -1) {
            obj = url.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
        }
        return ops;
    };

    //   checkCertification = () => {
    //     let _this = this;
    //     let url = "";
    //     if (localStorage.getItem("app_stoken")) {
    //       url =
    //         api.h5.checkCertification +
    //         "?app_stoken=" +
    //         localStorage.getItem("app_stoken");
    //     } else if (localStorage.getItem("sessionKey")) {
    //       url =
    //         api.wechat.checkCertification +
    //         "?sessionKey=" +
    //         localStorage.getItem("sessionKey");
    //     } else {
    //       url =
    //         api.h5.checkCertification +
    //         "?session_key=" +
    //         Cookies.get("session_key");
    //     }
    //     post({
    //       url: url,
    //       data: {},
    //     }).then(
    //       (res) => {
    //         console.log("校验是否实名", res);
    //         // Toast.info(res.msg,1);
    //         if (res.result === "success") {
    //           if (!res.data.account) {
    //             this.setState({
    //               status: "error",
    //             });
    //           } else {
    //             // href('/ACFaceCa');
    //             this.setState(
    //               {
    //                 status: "success",
    //               },
    //               () => {
    //                 // this.generateSignUrl();
    //                 this.selectSignPlatForm();
    //               }
    //             );
    //           }
    //         } else {
    //           if (res.code == "-1") {
    //             href("/ACLogin");
    //             Toast.info("登录失效", 1);
    //           } else {
    //             Toast.info("校验是否实名失败", 1);
    //           }
    //         }
    //       },
    //       (res) => {
    //         console.log("校验是否实名失败", res);
    //         if (res.code == "-1") {
    //           href("/ACLogin");
    //           Toast.info("登录失效", 1);
    //         } else {
    //           Toast.info("校验是否实名失败", 1);
    //         }
    //       }
    //     );
    //   };

    generateSignUrl = () => {
        let _this = this;
        let url = "";
        if (localStorage.getItem("app_stoken")) {
            url =
                api.h5.generateSignUrl +
                "?app_stoken=" +
                localStorage.getItem("app_stoken");
        } else if (localStorage.getItem("sessionKey")) {
            url =
                api.wechat.generateSignUrl +
                "?sessionKey=" +
                localStorage.getItem("sessionKey");
        } else {
            url =
                api.h5.generateSignUrl +
                "?session_key=" +
                Cookies.get("session_key");
        }
        loadingToast("签署地址生成中...");
        post({
            url: url,
            data: {
                thirdContractId: localStorage.getItem("thirdContractId"),
            },
        }).then(
            (res) => {
                Toast.hide();
                if (res.result === "success") {
                    _this.setState({
                        url: res.data,
                    });
                } else {
                    if (res.code == "-1") {
                        href("/ACLogin");
                        Toast.info("登录失效", 1);
                    } else {
                        Toast.info("签署地址生成失败", 1);
                    }
                }
            },
            (res) => {
                console.log("签署地址生成失败", res);
                if (res.code == "-1") {
                    href("/ACLogin");
                    Toast.info("登录失效", 1);
                } else {
                    Toast.info("签署地址生成失败", 1);
                }
            }
        );
    };

    render() {
        let { iconType, second, status } = this.state;
        return (
            <div className="ACFaceCaBox">
                <div>
                    {status === "error" ? (
                        <div className="error">
                            <div>
                                <Icon
                                    type="cross-circle-o"
                                    size="lg"
                                />
                                <span>认证失败</span>
                            </div>
                            <Button
                                type="primary"
                                onClick={() => {
                                    window.location.href = this.state.backUrl;
                                }}
                            >
                                重新认证
                            </Button>
                        </div>
                    ) : (
                        ""
                    )}

                    {status === "success" ? (
                        <div className="success">
                            <div>
                                <Icon
                                    type="check-circle"
                                    size="lg"
                                />
                                <span>申请成功</span>
                                <p>
                                    您已成功申请专属数字证书，用于远程慧联电子合同签署！
                                </p>
                            </div>
                            {this.state.url ? (
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        window.location.href = this.state.url;
                                    }}
                                >
                                    前往签署
                                </Button>
                            ) : (
                                <Button
                                    type="primary"
                                    disabled
                                >
                                    前往签署
                                </Button>
                            )}
                        </div>
                    ) : (
                        ""
                    )}

                    {status === "loading" ? (
                        <div className="loading">
                            <div>
                                <i></i>
                                <span>专属数字证书申请中</span>
                                <p>
                                    请耐心等待 <span>{second}</span> 秒
                                </p>
                            </div>
                            {/* <Button type="primary" disabled>前往签署</Button> */}
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        );
    }
}

export default ACFaceCa;



// WEBPACK FOOTER //
// ./src/authCertificate/ACFaceCa/index.js